document.addEventListener('DOMContentLoaded', function() {
    function specialC2EScription(){
      if(window.location.href.toLocaleLowerCase().indexOf("/products/indoorcam-p1") >= 0){
        if(document.getElementsByClassName("buy-buttons--multiple").length > 0){
          var element = document.getElementsByClassName("buy-buttons--multiple")[0];
          element.insertAdjacentHTML('afterend', '<buy-buttons class="buy-buttons buy-buttons--multiple" style="display:none;"><a href="https://www.aosulife.com/products/subscription-camera"><button type="button" class="button button--xl button--secondary" style="--button-text-color: 255 255 255;width: 300px;" is="custom-button"><div><div>Learn more</div><span class="button__loader"><span></span><span></span><span></span></span></div><span class="button__loader"><span></span><span></span><span></span></span></button></a></buy-buttons>');
        }

        if(window.location.href.indexOf("variant=46178280440044") > -1){
          document.getElementsByClassName("buy-buttons--multiple")[0].style.display = 'none';
          document.getElementsByClassName("buy-buttons--multiple")[1].style.display = '';
          window.location.href="https://www.aosulife.com/products/indoorcam-p1";
        }
        //document.getElementsByTagName("variant-option-value")[1].remove();
        var switchEle = document.getElementsByClassName("block-swatch");
        if(switchEle.length==2){
          if(switchEle[1].getAttribute("for").includes("free-camera")){
            switchEle[1].onclick = function(){
              window.location.href="https://www.aosulife.com/products/subscription-camera";
              document.getElementsByClassName("buy-buttons--multiple")[0].style.display = 'none';
              document.getElementsByClassName("buy-buttons--multiple")[1].style.display = '';
            }
          }
          if(switchEle[0].getAttribute("for").includes("camera-only")){
            switchEle[0].onclick = function(){
              document.getElementsByClassName("buy-buttons--multiple")[0].style.display = '';
              document.getElementsByClassName("buy-buttons--multiple")[1].style.display = 'none';
              document.getElementsByClassName("shopify-payment-button")[0].style.setProperty('display', 'block', 'important');
            }
          }
        }
      }
    }
    specialC2EScription();

    function changeDisCodeImage() {
      let href= window.location.href.toLocaleLowerCase();
      if((href.indexOf("/products/solarcam-d1-classic-kit")>=0 ||
         href.indexOf("solarcam-system-p1-se-system")>=0)
        && (href.indexOf("/products/solarcam-d1-classic-kit-video-doorbell-ultra-floodlight-cam-pro")==-1
           && href.indexOf("/products/solarcam-d1-classic-kit-video-doorbell-ultra-floodlight-cam-pro-indoorcam-p1-pro")==-1
           && href.indexOf("/products/solarcam-system-p1-se-system-video-doorbell-ultra")==-1
           )
        ){
          let _timerChangeDisCodeImage = setInterval(()=>{
              let _href= window.location.href.toLocaleLowerCase();
              if(_href.indexOf("/products/solarcam-d1-classic-kit")>=0 ||href.indexOf("solarcam-system-p1-se-system")>=0){
                if(_href.indexOf("variant=44531008209132")>=0 || _href.indexOf("variant=45834062987500")>=0){
                  if(document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].getAttribute("data-discount-code")!="aosu90"){
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].innerHTML = '<picture><source media="(min-width: 768px)" srcset="//cdn.shopify.com/s/files/1/0610/8830/1292/files/C9C_20250401_90.png?v=1743510181"><img src="//cdn.shopify.com/s/files/1/0610/8830/1292/files/C9C_20250401_90.png?v=1743510181" alt="Discount Image"></picture>';
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].setAttribute("data-discount-code","aosu90");
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].style.display = "block";
                  }
                }else{
                  if(document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].getAttribute("data-discount-code")!="aosu40"){
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].innerHTML = '<picture><source media="(min-width: 768px)" srcset="//cdn.shopify.com/s/files/1/0610/8830/1292/files/C9C_20250401_40.png?v=1743510182"><img src="//cdn.shopify.com/s/files/1/0610/8830/1292/files/C9C_20250401_40.png?v=1743510182" alt="Discount Image"></picture>';
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].setAttribute("data-discount-code","aosu40");
                    document.getElementsByClassName("discount-image-image_block_zAfQNB")[0].style.display = "block";
                  }
                }
              }
          }, 500);
      }
    }
    changeDisCodeImage();
});
window.addEventListener("load", ()=>{
    let firstDiv = document.querySelector("body > div:first-child");
    if(firstDiv){
        let sels = firstDiv.getElementsByClassName("recommendation-modal__container");
        if(sels && sels.length>0){
            firstDiv.style.setProperty("visibility", "hidden", "important");
        }else{
            firstDiv.style.setProperty("visibility", "visible", "important");
        }
    }
    let ua = navigator.userAgent;
    if(ua.indexOf("GlazeroWebView") == -1){
        let limitDiscount = 300;
        let countDiscount = 0;
        let timerDiscount = setInterval(()=>{
            let discountDivs = document.getElementsByClassName("react-responsive-modal-root");
            if(discountDivs && discountDivs.length>0){
                Array.from(discountDivs).forEach((discountDiv) => {
                    discountDiv.style.setProperty("visibility", "visible", "important");
                }); 
                clearInterval(timerDiscount);
            }
            if(timerDiscount > limitDiscount){
                clearInterval(timerDiscount);
            }
            countDiscount++;
        }, 200);
    
        let boundles = document.getElementsByClassName("selleasy-block-fbt");
        if(boundles && boundles.length>0){
            Array.from(boundles).forEach((boundle) => {
                boundle.style.setProperty("display", "block", "important");
            });
        }
    
        let buyItNowBtns = document.getElementsByClassName("shopify-payment-button");
        if(buyItNowBtns && buyItNowBtns.length>0){
            Array.from(buyItNowBtns).forEach((btn) => {
                btn.style.setProperty("display", "block", "important");
            });
        }
    }
  
    function hideAfterMarket(){
        if(window.location.href.toLocaleLowerCase().indexOf("/pages/referral") == -1){
          let limitAfterMarket = 300;
          let countAfterMarket = 0;
          let timerAfterMarket = setInterval(()=>{
              const pattern = /[A-Z][-]*/;
              var allTags = document.getElementsByTagName('*');
              for (var i = 0; i < allTags.length; i++) {
                  if(allTags[i].tagName.length>25 && allTags[i].tagName.indexOf("-")>-1){
                      if(allTags[i].shadowRoot){
                        var _shadowRoot = allTags[i].shadowRoot;
                        if(_shadowRoot.querySelector(".a-speed-dial")){
                          _shadowRoot.querySelector(".a-speed-dial").remove();
                          clearInterval(timerAfterMarket);
                        }
                      }
                  }
              }
              if(countAfterMarket > limitAfterMarket){
                  clearInterval(timerAfterMarket);
              }
              countAfterMarket++;
          }, 200);
        }else if(window.location.href.toLocaleLowerCase().indexOf("/pages/referral") >= 0){
          let limitAfterMarket = 400;
          let countAfterMarket = 0;
          let seccussCount = 0;
          let timerAfterMarket = setInterval(()=>{
              if(document.getElementsByClassName("kl-private-reset-css-Xuajs1").length>0){
                document.getElementsByClassName("kl-private-reset-css-Xuajs1")[0].parentNode.remove();
                seccussCount++;
              }
              if(document.getElementsByClassName("kl-teaser-Xpg2Un").length>0){
                if (document.getElementsByClassName("kl-teaser-Xpg2Un")[0] instanceof HTMLButtonElement) {
                  document.getElementsByClassName("kl-teaser-Xpg2Un")[0].parentNode.remove();
                  seccussCount++;
                }
              }
              if(countAfterMarket > limitAfterMarket){// || seccussCount == 2
                  clearInterval(timerAfterMarket);
              }
              countAfterMarket++;
          }, 200);
        }
    }
    hideAfterMarket();

    function hideGoogleRate(){
      let limitGoogleRate = 300;
      let countGoogleRate = 0;
      let timerGoogleRate = setInterval(()=>{
          var rateEle = document.getElementById("___ratingbadge_0");
          var rateEle1 = document.getElementById("___ratingbadge_1");
          if(rateEle){
              rateEle.remove();
              clearInterval(timerGoogleRate);
          }
          if(rateEle1){
              rateEle1.remove();
              clearInterval(timerGoogleRate);
          }
          if(countGoogleRate > limitGoogleRate){
              clearInterval(timerGoogleRate);
          }
          countGoogleRate++;
      }, 200);
    }
    hideGoogleRate();
});